var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(
      _vm.$route.name !== 'administration' &&
      _vm.$route.name !== 'administrationLogin' &&
      _vm.$route.name !== 'administrationNews' &&
      _vm.$route.name !== 'administrationAd' &&
      _vm.$route.name !== 'administrationAdEdit' &&
      _vm.$route.name !== 'administrationCareers' &&
      !(_vm.$route.name === 'kcmGroup' && _vm.$route.query.page === 'companies')
    )?_c('MobileHeader'):_vm._e(),_c('router-view'),_c('vue-snotify'),(
      _vm.$route.name !== 'administration' &&
      _vm.$route.name !== 'administrationLogin' &&
      _vm.$route.name !== 'administrationNews' &&
      _vm.$route.name !== 'administrationAd' &&
      _vm.$route.name !== 'administrationAdEdit' &&
      _vm.$route.name !== 'administrationCareers' &&
      !(_vm.$route.name === 'kcmGroup' && _vm.$route.query.page === 'companies')
    )?_c('Footer'):_vm._e(),_c('GDPR')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }